import Enum from '@/modules/core/app/helpers/Enum';

export class FlinksTokenErrorCode extends Enum {
  // 400
  static SESSION_NONEXISTENT = 'SESSION_NONEXISTENT';
  static CARD_IN_USE = 'CARD_IN_USE';

  // 401
  static INVALID_LOGIN = 'INVALID_LOGIN';
  static INVALID_REQUEST = 'INVALID_REQUEST';
  static INVALID_USERNAME = 'INVALID_USERNAME';
  static INVALID_PASSWORD = 'INVALID_PASSWORD';
  static INVALID_SECURITY_RESPONSE = 'INVALID_SECURITY_RESPONSE';
  static QUESTION_NOT_FOUND = 'QUESTION_NOT_FOUND';
  static RETRY_LATER = 'RETRY_LATER';
  static UNKNOWN_CHALLENGE_KEY = 'UNKNOWN_CHALLENGE_KEY';
  static CONCURRENT_SESSION = 'CONCURRENT_SESSION';
  static UNAUTHORIZED = 'UNAUTHORIZED';
  static DISABLED_LOGIN = 'DISABLED_LOGIN';
  static NEW_ACCOUNT = 'NEW_ACCOUNT';
  static SESSION_EXPIRED = 'SESSION_EXPIRED';
  static ALREADY_AUTHORIZED = 'ALREADY_AUTHORIZED';
  static SECURITYRESPONSES_INCOMPLETE = 'SECURITYRESPONSES_INCOMPLETE';

  // 404
  static NO_TRANSACTION = 'NO_TRANSACTION';

  // 405
  static DISABLED_INSTITUTION = 'DISABLED_INSTITUTION';

  // 500
  static AGGREGATION_ERROR = 'AGGREGATION_ERROR';

  // 501
  static METHOD_NOT_AVAILABLE = 'METHOD_NOT_AVAILABLE';

  static unauthorizedErrorCodes(): string[] {
    return [
      FlinksTokenErrorCode.SESSION_EXPIRED,
      FlinksTokenErrorCode.INVALID_LOGIN,
      FlinksTokenErrorCode.INVALID_REQUEST,
      FlinksTokenErrorCode.INVALID_USERNAME,
      FlinksTokenErrorCode.INVALID_PASSWORD,
      FlinksTokenErrorCode.INVALID_SECURITY_RESPONSE,
      FlinksTokenErrorCode.QUESTION_NOT_FOUND,
      FlinksTokenErrorCode.UNKNOWN_CHALLENGE_KEY,
      FlinksTokenErrorCode.CONCURRENT_SESSION,
      FlinksTokenErrorCode.UNAUTHORIZED,
      FlinksTokenErrorCode.DISABLED_LOGIN,
      FlinksTokenErrorCode.NEW_ACCOUNT,
      FlinksTokenErrorCode.SESSION_EXPIRED,
      FlinksTokenErrorCode.ALREADY_AUTHORIZED,
      FlinksTokenErrorCode.SECURITYRESPONSES_INCOMPLETE
    ];
  }
}
